import React from 'react'
import { ContentType } from '../../../../types';

export interface FAQsProps {
  faqs: ContentType[];
}

export default function FAQs({ faqs }: FAQsProps) {
  return (
    <div>
      {faqs.map(faq => {
        let data = JSON.parse(faq.data);
        return (
          <div>
            <h3>{data.Question}</h3>
            <p>{data.Answer}</p>
          </div>
        );
      })}
    </div>
  )
}
